export const CONFIRMATION_MODAL = {
	DEFAULT_CANCEL_LABEL: 'Cancelar',
	TITLE_ID: 'confirmation-modal-title'
} as const;
